<div class="metadata">
  <h4 style="margin-bottom: 0" i18n="@@aboutPage-title">Website Information:</h4>
  <span *ngIf="env"><span i18n="@@aboutPage-version">Version: </span>{{env.version}}</span>
  <h4 style="margin-bottom: 0" i18n="@@aboutPage-title">API Information:</h4>
  <span *ngIf="build"><span i18n="@@aboutPage-apiVersion">Version:</span> {{build.version}} </span>
    <br/>
  <span> <span i18n="@@aboutPage-lastUpdate">Dernière mise à jour:</span> {{build.time | date:'medium'}}</span>
</div>
